import { createApp, ref, onMounted, computed } from 'vue'

const app = createApp({
  setup() {
    const fileSizeOver = ref(false) //ファイルサイズがオーバーかどうか
    const fileTypeStatement = ref(false) //ファイルの種類が適切かどうか
    const MBunit = 1048576 //MB数変換用

    // 画像ファイル選択時に大きさとフォーマットをチェックする
    const imageChange = (event, MAXfileSize) => {
      if (event.target.files[0].type === 'image/jpeg' || event.target.files[0].type === 'image/png') {
        fileTypeStatement.value = false
      } else {
        fileTypeStatement.value = true
      }
      // console.log(fileTypeStatement.value)
      let fileSize = event.target.files[0].size / MBunit
      if (fileSize > MAXfileSize) {
        fileSizeOver.value = true
      } else {
        fileSizeOver.value = false
      }
      // console.log(fileSize)
    }

    // ボタンの状態を管理する(どちらか片方がtrueでボタンを押せなくする)
    const buttonStatement = computed(() => ({
      'c-button--false': fileSizeOver.value || fileTypeStatement.value
    }))

    return { fileTypeStatement, fileSizeOver, imageChange, buttonStatement }
  }
})
if (document.getElementById('productControl')) {
  app.mount('#productControl')
}
